require("source-map-support").install(), function (n, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("Dropdown", [], e) : "object" == typeof exports ? exports.Dropdown = e() : n.Dropdown = e();
}(this, function () {
  return function (n) {
    var e = {};

    function r(t) {
      if (e[t]) return e[t].exports;
      var o = e[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return n[t].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = n, r.c = e, r.d = function (n, e, t) {
      r.o(n, e) || Object.defineProperty(n, e, {
        enumerable: !0,
        get: t
      });
    }, r.r = function (n) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(n, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(n, "__esModule", {
        value: !0
      });
    }, r.t = function (n, e) {
      if (1 & e && (n = r(n)), 8 & e) return n;
      if (4 & e && "object" == typeof n && n && n.__esModule) return n;
      var t = Object.create(null);
      if (r.r(t), Object.defineProperty(t, "default", {
        enumerable: !0,
        value: n
      }), 2 & e && "string" != typeof n) for (var o in n) {
        r.d(t, o, function (e) {
          return n[e];
        }.bind(null, o));
      }
      return t;
    }, r.n = function (n) {
      var e = n && n.__esModule ? function () {
        return n.default;
      } : function () {
        return n;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (n, e) {
      return Object.prototype.hasOwnProperty.call(n, e);
    }, r.p = "/", r(r.s = 343);
  }({
    0: function _(n, e) {
      n.exports = require("react");
    },
    1: function _(n, e) {
      n.exports = require("prop-types");
    },
    108: function _(n, e) {
      n.exports = require("@fortawesome/pro-solid-svg-icons/faChevronUp");
    },
    12: function _(n, e) {
      n.exports = require("@fortawesome/react-fontawesome");
    },
    13: function _(n, e, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(0),
          a = r.n(i),
          c = r(1),
          s = r.n(c),
          u = r(2),
          l = r.n(u),
          f = r(7);

      function d() {
        var n = o()(["\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
        return d = function d() {
          return n;
        }, n;
      }

      var p = l()(function (n) {
        var e = n.children,
            r = n.className;
        return a.a.Children.only(a.a.cloneElement(e, {
          className: r
        }));
      })(d(), function (n) {
        var e = n.margin;
        return Object(f.a)({
          attribute: "margin",
          value: e
        });
      }, function (n) {
        var e = n.marginTop;
        return Object(f.a)({
          attribute: "margin-top",
          value: e
        });
      }, function (n) {
        var e = n.marginBottom;
        return Object(f.a)({
          attribute: "margin-bottom",
          value: e
        });
      }, function (n) {
        var e = n.marginLeft;
        return Object(f.a)({
          attribute: "margin-left",
          value: e
        });
      }, function (n) {
        var e = n.marginRight;
        return Object(f.a)({
          attribute: "margin-right",
          value: e
        });
      });
      p.propTypes = {
        margin: s.a.oneOfType([s.a.string, s.a.number]),
        marginTop: s.a.oneOfType([s.a.string, s.a.number]),
        marginBottom: s.a.oneOfType([s.a.string, s.a.number]),
        marginLeft: s.a.oneOfType([s.a.string, s.a.number]),
        marginRight: s.a.oneOfType([s.a.string, s.a.number])
      }, e.a = p;
    },
    14: function _(n, e) {
      n.exports = require("lodash.memoize");
    },
    16: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/getPrototypeOf");
    },
    172: function _(n, e, r) {
      "use strict";

      r.r(e);
      var t = r(80);
      e.default = t.a;
    },
    18: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/assertThisInitialized");
    },
    2: function _(n, e) {
      n.exports = require("styled-components");
    },
    22: function _(n, e) {
      n.exports = require("@fortawesome/fontawesome-svg-core");
    },
    23: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/classCallCheck");
    },
    24: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/createClass");
    },
    25: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/inherits");
    },
    26: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/possibleConstructorReturn");
    },
    27: function _(n, e) {
      n.exports = require("react-select");
    },
    3: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/taggedTemplateLiteral");
    },
    343: function _(n, e, r) {
      n.exports = r(172);
    },
    4: function _(n) {
      n.exports = JSON.parse('{"white":"#ffffff","brand":"#0d51ff","brand10":"#e6edff","brand20":"#c5d2f5","brand40":"#96b1f7","brand60":"#6992fa","brand80":"#3a71fc","brand120":"#0a40cc","brand140":"#073099","brand160":"#052066","brand180":"#021033","grey":"#475b68","grey10":"#f8f8f8","grey20":"#f0f0f0","grey40":"#bbc3ca","grey60":"#919da4","grey80":"#6c7c86","grey120":"#384853","grey140":"#2a363e","grey160":"#1c2429","grey180":"#0e1214","success":"#00ab5b","successhover":"#008848","successlight":"#66cd9d","successbackground":"#e5f6ee","warninghover":"#cc9c00","warning":"#ffc400","warninglight":"#ffdc66","warningabsence":"#ffedb2","warningbackground":"#fff9e6","alerthover":"#cc180b","alert":"#ff1e0e","alertlight":"#ff786e","alertbackground":"#ffe8e6","infohover":"#b01863","info":"#dc1e7c","infolight":"#ea78b0","infobackground":"#fbe8f2","supporthover":"#583ac3","support":"#6e49f4","supportlight":"#a892f8","supportbackground":"#f0ecfe","boxshadowmedium":"rgba(71, 91, 104, 0.1)","modaloverlay":"rgba(2, 16, 51, 0.5)","transparent":"transparent"}');
    },
    5: function _(n, e, r) {
      "use strict";

      r.d(e, "a", function () {
        return b;
      }), r.d(e, "e", function () {
        return i;
      }), r.d(e, "j", function () {
        return a;
      }), r.d(e, "f", function () {
        return c;
      }), r.d(e, "g", function () {
        return s;
      }), r.d(e, "i", function () {
        return f;
      }), r.d(e, "c", function () {
        return d;
      }), r.d(e, "k", function () {
        return d;
      }), r.d(e, "l", function () {
        return p;
      }), r.d(e, "b", function () {
        return g;
      }), r.d(e, "d", function () {
        return h;
      }), r.d(e, "h", function () {
        return l;
      });

      var t = r(4),
          o = r(9),
          i = function i(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "primary":
            return e.brand;

          case "secondary":
          case "normal":
          default:
            return e.grey;

          case "info":
            return e.info;

          case "support":
            return e.support;

          case "success":
            return e.success;

          case "warning":
            return e.warning;

          case "alert":
            return e.alert;

          case "brand160":
            return e.brand160;

          case "white":
            return e.white;
        }
      },
          a = function a(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "primary":
            return e.brand60;

          case "secondary":
          case "normal":
          default:
            return e.grey40;

          case "info":
            return e.infolight;

          case "support":
            return e.supportlight;

          case "success":
            return e.successlight;

          case "warning":
            return e.warninglight;

          case "alert":
            return e.alertlight;

          case "grey20":
          case "white":
            return e.grey20;
        }
      },
          c = function c(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "primary":
            return e.brand120;

          case "secondary":
          case "normal":
          default:
            return e.grey140;

          case "info":
            return e.infohover;

          case "support":
            return e.supporthover;

          case "success":
            return e.successhover;

          case "warning":
            return e.warninghover;

          case "alert":
            return e.alerthover;

          case "white":
            return e.grey20;
        }
      },
          s = function s(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o;

        switch (n) {
          case "xxs":
            return e.Body4;

          case "xs":
            return e.Body3;

          case "sm":
            return e.Body2;

          case "md":
          default:
            return e.Body1;

          case "lg":
            return e.H5;

          case "xl":
            return e.H4;

          case "xxl":
            return e.H3;

          case "xxxl":
            return e.H2;

          case "xxxxl":
            return e.H1;
        }
      },
          u = Object.freeze({
        xs: 24,
        sm: 30,
        md: 40,
        lg: 50
      }),
          l = function l(n) {
        return u[n] || u.md;
      },
          f = function f(n, e) {
        var r = {
          padding: {
            vertical: 0,
            horizontal: 10
          },
          font: {},
          supportFont: {},
          height: 0
        };

        switch (n) {
          case "xs":
            r.padding.vertical = 6, r.font = e.Body3, r.supportFont = e.Body4;
            break;

          case "sm":
            r.padding.vertical = 8, r.font = e.Body1, r.supportFont = e.Body3;
            break;

          default:
          case "md":
            r.padding.vertical = 12, r.font = e.Body1, r.supportFont = e.Body3;
            break;

          case "lg":
            r.padding.vertical = 17, r.font = e.Body1, r.supportFont = e.Body3;
        }

        return r.height = l(n), r;
      },
          d = function d(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "primary":
            return e.brand10;

          case "info":
            return e.infobackground;

          case "support":
            return e.supportbackground;

          case "success":
            return e.successbackground;

          case "warning":
            return e.warningbackground;

          case "alert":
            return e.alertbackground;

          case "normal":
          default:
            return e.white;
        }
      },
          p = function p(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "warning":
            return e.brand160;

          case "info":
          case "support":
          case "success":
          case "alert":
          default:
            return e.white;
        }
      },
          g = function g(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "info":
            return e.info;

          case "support":
            return e.support;

          case "success":
            return e.success;

          case "warning":
            return e.warning;

          case "alert":
            return e.alert;

          default:
            return e.brand;
        }
      },
          h = function h(n) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : t;

        switch (n) {
          case "info":
            return e.info;

          case "support":
            return e.support;

          case "success":
            return e.success;

          case "warning":
            return e.warning;

          case "alert":
            return e.alert;

          default:
            return e.brand;
        }
      },
          b = new Map([[0, "rgb(110,73,244)"], [1, "#098256"], [2, "#7300B3"], [3, "#052066"], [4, "#6E49F4"], [5, "#0A40CC"], [6, "#FFB300"], [7, "#FF1E0E"], [8, "#038F00"], [9, "#CC34AF"], [10, "#11AEEF"], [11, "#475B68"], [12, "#DC1E7C"], [13, "#30C881"], [14, "#FF6A12"], [15, "#2D9898"]]);
    },
    51: function _(n, e) {
      n.exports = require("@fortawesome/pro-solid-svg-icons/faChevronDown");
    },
    52: function _(n, e) {
      n.exports = require("@fortawesome/pro-solid-svg-icons/faTimes");
    },
    53: function _(n, e) {
      n.exports = require("react-select/async");
    },
    59: function _(n, e, r) {
      "use strict";

      var t = r(2),
          o = r.n(t).a.label({});
      e.a = o;
    },
    6: function _(n, e) {
      n.exports = require("@babel/runtime/helpers/defineProperty");
    },
    69: function _(n, e) {
      n.exports = require("@fortawesome/free-solid-svg-icons");
    },
    7: function _(n, e, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(2);

      function a() {
        var n = o()(["", ": ", ""]);
        return a = function a() {
          return n;
        }, n;
      }

      function c() {
        var n = o()(["", ": ", "px"]);
        return c = function c() {
          return n;
        }, n;
      }

      e.a = function (n) {
        var e = n.attribute,
            r = n.value;

        if (void 0 !== r) {
          if ("number" == typeof r) return Object(i.css)(c(), e, r);
          if ("string" == typeof r) return Object(i.css)(a(), e, r);
          throw new Error("".concat(r, " is not of valid type for ").concat(e, ".\n      prop can either number or string"));
        }
      };
    },
    74: function _(n, e, r) {
      "use strict";

      var t = r(0),
          o = r.n(t),
          i = r(3),
          a = r.n(i),
          c = r(6),
          s = r.n(c),
          u = r(1),
          l = r.n(u),
          f = r(2),
          d = r.n(f),
          p = r(12),
          g = r(69),
          h = d.a.input.attrs({
        type: "checkbox"
      })({}),
          b = r(59),
          m = r(8),
          y = r(5);

      function v() {
        var n = a()(["\n  display: inline-flex;\n  align-items: center;\n  flex: 0 0 ", "px;\n\n  height: ", "px;\n  width: ", "px;\n\n  border-radius: 3px;\n  border: solid 1px ", ";\n\n  ", ";\n\n  transition-duration: .15s;\n  transition-property: background-color, border;\n  transition-timing-function: ease-in-out;\n\n  background-color: ", ";\n\n  & svg {\n    ", ";\n    opacity: ", ";\n    color: ", ";\n  }\n"]);
        return v = function v() {
          return n;
        }, n;
      }

      function x() {
        var n = a()(["\n  display: block;\n  margin: 0 auto;\n\n  transition-duration: .15s;\n  transition-property: opacity, color;\n  transition-timing-function: ease-in-out;\n  z-index: 1;\n"]);
        return x = function x() {
          return n;
        }, n;
      }

      function O() {
        var n = a()(["\n  position: absolute;\n  margin: 0;\n  height: 0;\n  width: 0;\n\n  opacity: 0;\n\n  cursor: pointer;\n"]);
        return O = function O() {
          return n;
        }, n;
      }

      function w() {
        var n = a()(["\n  display: inline-block;\n  line-height: ", "px;\n"]);
        return w = function w() {
          return n;
        }, n;
      }

      function j() {
        var n = a()(["\n  display: inline-flex;\n  position: relative;\n  align-items: center;\n  padding-left: ", "px;\n\n  ", ";\n  ", ";\n\n  cursor: ", ";\n\n  user-select: none;\n"]);
        return j = function j() {
          return n;
        }, n;
      }

      function k() {
        var n = a()(["", ": 10px;"]);
        return k = function k() {
          return n;
        }, n;
      }

      function z() {
        var n = a()(["\n    font-size: ", "px;\n  "]);
        return z = function z() {
          return n;
        }, n;
      }

      function _() {
        var n = a()(["min-height: ", "px"]);
        return _ = function _() {
          return n;
        }, n;
      }

      function S() {
        var n = a()(["\n    line-height: ", "px;\n    font-family: ", ";\n    font-size: ", "px;\n  "]);
        return S = function S() {
          return n;
        }, n;
      }

      function F(n, e) {
        var r = Object.keys(n);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(n);
          e && (t = t.filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })), r.push.apply(r, t);
        }

        return r;
      }

      var P = function P(n) {
        switch (n.size) {
          case "lg":
            return 20;

          case "md":
          default:
            return 16;

          case "sm":
            return 12;
        }
      },
          D = function D(n) {
        var e = n.version,
            r = n.checked,
            t = n.disabled,
            o = n.uistyle,
            i = n.theme.colors,
            a = function (n) {
          var e,
              r,
              t = n.uistyle,
              o = n.colors,
              i = n.disabled;

          switch (t) {
            case "primary":
            default:
              e = o.brand, r = o.brand60;
              break;

            case "secondary":
              e = o.grey, r = o.grey40;
          }

          return i ? r : e;
        }({
          uistyle: o,
          colors: i,
          disabled: t
        }),
            c = a,
            s = a,
            u = i.white;

        if ("ghost" === e) {
          var l = [s, u];
          u = l[0], s = l[1];
        }

        if (!r) {
          var f = [i.white, i.white];
          u = f[0], s = f[1];
        }

        return {
          color: u,
          border: c,
          background: s
        };
      },
          C = d()(b.a)(j(), function (n) {
        return n.indent ? 10 : 0;
      }, function (n) {
        var e,
            r = n.size;
        if (!n.fitSizeHeight) return "";

        switch (r) {
          case "lg":
            e = 50;
            break;

          default:
          case "md":
            e = 40;
            break;

          case "sm":
            e = 30;
            break;

          case "xs":
            e = 24;
        }

        return Object(f.css)(_(), e);
      }, function (n) {
        var e = n.theme.fonts,
            r = n.size,
            t = Object(y.i)(r, e).font,
            o = function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2 ? F(Object(r), !0).forEach(function (e) {
              s()(n, e, r[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : F(Object(r)).forEach(function (e) {
              Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
            });
          }

          return n;
        }({}, t);

        switch (r) {
          case "sm":
            o.lineHeight = 18;
            break;

          case "md":
          case "lg":
          default:
            o.lineHeight = t.fontSize;
        }

        return Object(f.css)(S(), o.lineHeight, o.fontFamily, o.fontSize);
      }, function (n) {
        return n.disabled ? "not-allowed" : "pointer";
      });

      C.propTypes = {
        disabled: l.a.bool,
        htmlFor: l.a.string,
        size: l.a.oneOf(["sm", "md", "lg"])
      }, C.defaultProps = {
        disabled: !1,
        htmlFor: "",
        size: "md"
      }, C.displayName = "WrappingLabel";
      var E = d()(m.a)(w(), P);
      E.propTypes = {
        text: l.a.string.isRequired
      }, E.displayName = "LabelText";
      var H = d()(h)(O());
      H.displayName = "HiddenCheckboxInput";
      var T = d()(p.FontAwesomeIcon).attrs({
        icon: function icon(n) {
          return "line" === n.version ? g.faMinus : g.faCheck;
        }
      })(x());
      T.displayName = "CheckMarkIcon";
      var B = d.a.div.attrs({
        children: function children(n) {
          var e = n.version;
          return o.a.cloneElement(o.a.createElement(T, null), {
            version: e
          });
        }
      })(v(), P, P, P, function (n) {
        return D(n).border;
      }, function (n) {
        var e = "right" === n.labelSide ? "margin-right" : "margin-left";
        return n.hasText ? Object(f.css)(k(), e) : "";
      }, function (n) {
        return D(n).background;
      }, function (n) {
        var e;

        switch (n.size) {
          case "lg":
            e = 12;
            break;

          case "md":
          default:
            e = 10;
            break;

          case "sm":
            e = 8;
        }

        return Object(f.css)(z(), e);
      }, function (n) {
        return n.checked ? 1 : 0;
      }, function (n) {
        return D(n).color;
      });
      B.propTypes = {
        hasText: l.a.bool,
        version: l.a.oneOf(["regular", "ghost", "line"]),
        size: l.a.oneOf(["sm", "md", "lg"]),
        labelSide: l.a.oneOf(["left", "right"]),
        checked: l.a.bool,
        disabled: l.a.bool,
        uistyle: l.a.oneOf(["primary", "secondary"])
      }, B.defaultProps = {
        hasText: !1,
        version: "regular",
        size: "md",
        labelSide: "left",
        checked: !1,
        disabled: !1,
        uistyle: "primary"
      }, B.displayName = "CheckMark";

      var R = function R(n) {
        var e = n.id,
            r = n.onChange,
            t = n.text,
            i = n.size,
            a = n.name,
            c = n.checked,
            s = n.labelSide,
            u = n.version,
            l = n.uistyle,
            f = n.disabled,
            d = n.fitSizeHeight,
            p = n.indent,
            g = n.inputRef,
            h = n.onFocus,
            b = n.onBlur,
            m = o.a.createElement(E, {
          lighter: f,
          text: t,
          key: "label",
          size: i
        }),
            y = o.a.createElement(B, {
          version: u,
          size: i,
          labelSide: s,
          hasText: !!t,
          checked: c,
          disabled: f,
          uistyle: l,
          key: "checkmark"
        }),
            v = o.a.createElement(H, {
          disabled: f,
          id: e,
          onChange: r,
          size: i,
          text: t,
          labelSide: s,
          name: a,
          checked: c,
          key: "checkbox"
        }),
            x = "left" === s ? [m, y, v] : [y, m, v];
        return o.a.createElement(C, {
          disabled: f,
          htmlFor: e,
          size: i,
          fitSizeHeight: d,
          indent: p,
          innerRef: g,
          onFocus: h,
          onBlur: b
        }, x);
      };

      R.defaultProps = {
        onChange: function onChange() {},
        version: "regular",
        text: "",
        name: "",
        size: "md",
        checked: !1,
        labelSide: "left",
        uistyle: "primary",
        disabled: !1,
        fitSizeHeight: !1,
        indent: !1,
        inputRef: o.a.createRef(),
        onFocus: void 0,
        onBlur: void 0
      };
      e.a = R;
    },
    8: function _(n, e, r) {
      "use strict";

      var t = r(3),
          o = r.n(t),
          i = r(2),
          a = r.n(i),
          c = r(1),
          s = r.n(c),
          u = r(14),
          l = r.n(u),
          f = r(5);

      function d() {
        var n = o()(["\n    color: ", ";\n  "]);
        return d = function d() {
          return n;
        }, n;
      }

      function p() {
        var n = o()(["\n    line-height: ", "px;\n    font-size: ", "px;\n    font-family: ", ";\n  "]);
        return p = function p() {
          return n;
        }, n;
      }

      var g = l()(function (n) {
        var e = n.theme.fonts,
            r = n.size,
            t = Object(f.g)(r, e);
        return Object(i.css)(p(), t.lineHeight, t.fontSize, t.fontFamily);
      }, function (n) {
        return n.size;
      }),
          h = l()(function (n) {
        var e = n.lighter,
            r = n.theme.colors,
            t = n.uistyle,
            o = e ? Object(f.j)(t, r) : Object(f.e)(t, r);
        return Object(i.css)(d(), o);
      }, function (n) {
        var e = n.lighter,
            r = n.uistyle;
        return "".concat(e, "-").concat(r);
      });

      function b() {
        var n = o()(["\n  transition: 0.15s ease-in-out color;\n  ", "\n  ", "\n  font-weight: ", ";\n\n  padding: 0;\n  margin: 0;\n"]);
        return b = function b() {
          return n;
        }, n;
      }

      var m = a.a.p.attrs({
        children: function children(n) {
          return n.children || n.text;
        }
      })(b(), h, g, function (n) {
        return n.weight;
      });
      m.propTypes = {
        uistyle: s.a.string,
        size: s.a.oneOf(["xxl", "xl", "lg", "md", "sm", "xs", "xxs"]),
        lighter: s.a.bool,
        weight: s.a.oneOf(["normal", "bold", 600])
      }, m.defaultProps = {
        uistyle: "normal",
        size: "md",
        lighter: !1,
        weight: "normal"
      }, m.displayName = "Text";
      e.a = m;
    },
    80: function _(n, e, r) {
      "use strict";

      var t = r(23),
          o = r.n(t),
          i = r(24),
          a = r.n(i),
          c = r(18),
          s = r.n(c),
          u = r(25),
          l = r.n(u),
          f = r(26),
          d = r.n(f),
          p = r(16),
          g = r.n(p),
          h = r(6),
          b = r.n(h),
          m = r(0),
          y = r.n(m),
          v = r(22),
          x = r(51),
          O = r(108),
          w = r(52),
          j = r(3),
          k = r.n(j),
          z = r(2),
          _ = r.n(z),
          S = r(27),
          F = r.n(S),
          P = r(53),
          D = r.n(P),
          C = r(12),
          E = r(5),
          H = r(13),
          T = r(74);

      function B() {
        var n = k()(["\n  ", "\n"]);
        return B = function B() {
          return n;
        }, n;
      }

      function R() {
        var n = k()(["\n  ", "\n"]);
        return R = function R() {
          return n;
        }, n;
      }

      function q() {
        var n = k()(["\n  ", ";\n  color: ", ";\n\n  width: ", ";\n\n  .rs__value-container {\n    margin: 0 10px;\n    padding: 0;\n    height: 100%;\n\n    > div, .rs__input, input {\n      max-width: 100%;\n      margin-right: 0;\n      margin-left: 0;\n    }\n\n    .rs__input {\n      color: ", ";\n    }\n\n    .rs__input input {\n      ", "\n    }\n\n    .rs__single-value {\n      transition: 0.15s ease-in-out color;\n      color: ", ";\n    }\n\n    .rs__placeholder {\n      color: ", ";\n      transition: color .15s ease-in-out;\n    }\n  }\n\n  > .rs__control {\n    height: ", "px;\n    min-height: unset;\n\n    box-sizing: border-box;\n    margin: 0px;\n\n\n    pointer-events: all;\n    ", ";\n\n    background-color: ", ";\n    border-radius: 3px;\n    ", ";\n\n    transition-duration: 0.15s;\n    transition-timing-function: ease-in-out;\n    transition-property: background-color, border, color;\n\n    &:hover {\n      border: 1px solid ", ";\n    }\n\n    &--is-focused, &:focus {\n      .rs__value-container .rs__placeholder {\n        color: ", ";\n      }\n    }\n\n    &:focus, &:active, &--is-focused, &--is-focused:hover {\n      box-shadow: none;\n      border: 1px solid ", ";\n    }\n  }\n\n  .rs__indicator-separator {\n    display: none;\n  }\n\n  .rs__dropdown-indicator {\n    padding: 0 10px 0 0;\n\n    svg path {\n      transition-property: fill;\n      transition-timing-function: ease-in-out;\n      transition-duration: 0.15s;\n      fill: ", ";\n    }\n  }\n\n  .rs__clear-indicator {\n    margin-right: 5px;\n    padding: 5px 5px 5px 0;\n\n    svg {\n      color: ", ";\n    }\n\n    &:hover svg {\n      color: ", ";\n    }\n  }\n\n  .rs__menu-list {\n    padding: 0;\n  }\n\n  .rs__menu {\n    width: ", ";\n    border-radius: 3px;\n\n    color: ", ";\n    box-shadow: 0 0 4px 1px ", ";\n\n    ", ";\n\n    & .rs__option {\n      border-radius: 3px;\n      cursor: pointer;\n\n      display: flex;\n      align-items: center;\n\n      height: ", "px;\n\n      label {\n        height: 100%;\n\n        input {\n          align-self: flex-start;\n        }\n      }\n    }\n\n    .rs__option.rs__option--is-focused {\n      background-color: ", ";\n    }\n\n    .rs__option--is-selected, .rs__menu-notice--no-options {\n      color: ", ";\n      background-color: white;\n    }\n  }\n"]);
        return q = function q() {
          return n;
        }, n;
      }

      function M() {
        var n = k()(["\n  & .rs__option:nth-of-type(1n+", "){\n    display: none;\n  }\n"]);
        return M = function M() {
          return n;
        }, n;
      }

      function I() {
        var n = k()(["\n  font-size: 9px;\n"]);
        return I = function I() {
          return n;
        }, n;
      }

      function L(n, e) {
        var r = Object.keys(n);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(n);
          e && (t = t.filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })), r.push.apply(r, t);
        }

        return r;
      }

      function W(n) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? L(Object(r), !0).forEach(function (e) {
            b()(n, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : L(Object(r)).forEach(function (e) {
            Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return n;
      }

      function A() {
        var n = k()(["\n    cursor: ", ";\n  "]);
        return A = function A() {
          return n;
        }, n;
      }

      function N() {
        var n = k()(["\n    border: 1px solid ", ";\n  "]);
        return N = function N() {
          return n;
        }, n;
      }

      function U() {
        var n = k()(["\n    font-family: ", ";\n    font-size: ", "px;\n  "]);
        return U = function U() {
          return n;
        }, n;
      }

      var G = function G(n) {
        var e = n.theme.fonts,
            r = n.size,
            t = Object(E.i)(r, e).font;
        return Object(z.css)(U(), t.fontFamily, t.fontSize);
      },
          J = function J(n) {
        var e = n.theme.fonts,
            r = n.size;
        return Object(E.i)(r, e).height;
      },
          V = function V(n) {
        var e,
            r = n.containsError,
            t = n.isDisabled,
            o = n.theme.colors;
        return e = t ? o.grey20 : r ? o.alert : o.grey40, Object(z.css)(N(), e);
      },
          K = function K(n) {
        var e,
            r = n.isDisabled,
            t = n.isSearchable;
        return e = r ? "not-allowed" : t ? "text" : "pointer", Object(z.css)(A(), e);
      },
          Q = function Q(n) {
        var e = n.hasTitle,
            r = n.isSearchable,
            t = n.theme.colors;
        return e || r ? t.grey40 : t.grey;
      },
          X = function X(n) {
        var e = n.value,
            r = n.label;
        return y.a.createElement(H.a, {
          marginLeft: 16,
          marginRight: 16,
          marginTop: 12,
          marginBottom: 12
        }, y.a.createElement("div", null, y.a.createElement(T.a, {
          id: e,
          text: r,
          labelSide: "right"
        })));
      },
          Y = function Y(n) {
        var e = n.selectProps,
            r = e.value,
            t = e.placeholder,
            o = t.initial;
        return r && Array.isArray(r) && r.length > 0 && (o = "".concat(r.length, " ").concat(r.length > 1 ? t.plural : t.selected)), y.a.createElement(S.components.Placeholder, W({}, n), o);
      },
          Z = _()(C.FontAwesomeIcon)(I()),
          $ = function $(n) {
        var e = n.selectProps.menuIsOpen,
            r = "chevron-".concat(e ? "up" : "down");
        return y.a.createElement(S.components.DropdownIndicator, W({}, n), y.a.createElement(Z, {
          icon: ["fas", r]
        }));
      },
          nn = function nn(n) {
        return y.a.createElement(S.components.ClearIndicator, W({}, n), y.a.createElement(C.FontAwesomeIcon, {
          icon: ["fas", "times"],
          size: "xs"
        }));
      },
          en = function en(n) {
        var e = n.numberOfOptions;
        return e && Object(z.css)(M(), e + 1);
      },
          rn = function rn() {
        return Object(z.css)(q(), G, function (n) {
          var e = n.isFocus,
              r = n.theme.colors;
          return e ? r.grey40 : r.brand160;
        }, function (n) {
          return n.fullWidth ? "100%" : "300px";
        }, function (n) {
          var e = n.isDisabled,
              r = n.theme.colors;
          return e ? r.grey40 : r.brand160;
        }, G, function (n) {
          var e = n.isDisabled,
              r = n.theme.colors;
          return e ? r.grey40 : r.brand160;
        }, function (n) {
          var e = n.hasTitle,
              r = n.isDisabled,
              t = n.theme.colors;
          return e || r ? t.grey40 : t.grey;
        }, J, K, function (n) {
          var e = n.isDisabled,
              r = n.theme.colors;
          return e ? r.grey20 : r.white;
        }, V, function (n) {
          var e = n.isDisabled,
              r = n.theme.colors;
          return e ? r.grey20 : r.grey;
        }, Q, function (n) {
          var e = n.isDisabled,
              r = n.theme.colors;
          return e ? r.grey20 : r.brand;
        }, function (n) {
          var e = n.isDisabled,
              r = n.theme.colors;
          return e ? r.grey40 : r.grey;
        }, function (n) {
          return n.theme.colors.grey40;
        }, function (n) {
          return n.theme.colors.grey;
        }, function (n) {
          var e = n.width;
          return n.fullWidth ? "100%" : "".concat(e, "px");
        }, function (n) {
          return n.theme.colors.grey;
        }, function (n) {
          return n.theme.colors.boxshadowmedium;
        }, en, J, function (n) {
          return n.theme.colors.brand20;
        }, function (n) {
          return n.theme.colors.grey;
        });
      },
          tn = _()(D.a)(R(), rn),
          on = _()(F.a)(B(), rn);

      function an(n, e) {
        var r = Object.keys(n);

        if (Object.getOwnPropertySymbols) {
          var t = Object.getOwnPropertySymbols(n);
          e && (t = t.filter(function (e) {
            return Object.getOwnPropertyDescriptor(n, e).enumerable;
          })), r.push.apply(r, t);
        }

        return r;
      }

      function cn(n) {
        for (var e = 1; e < arguments.length; e++) {
          var r = null != arguments[e] ? arguments[e] : {};
          e % 2 ? an(Object(r), !0).forEach(function (e) {
            b()(n, e, r[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : an(Object(r)).forEach(function (e) {
            Object.defineProperty(n, e, Object.getOwnPropertyDescriptor(r, e));
          });
        }

        return n;
      }

      function sn() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (n) {
          return !1;
        }
      }

      v.library.add(x.faChevronDown, O.faChevronUp, w.faTimes);

      var un = function (n) {
        l()(t, n);
        var e,
            r = (e = t, function () {
          var n,
              r = g()(e);

          if (sn()) {
            var t = g()(this).constructor;
            n = Reflect.construct(r, arguments, t);
          } else n = r.apply(this, arguments);

          return d()(this, n);
        });

        function t() {
          var n;
          o()(this, t);

          for (var e = arguments.length, i = new Array(e), a = 0; a < e; a++) {
            i[a] = arguments[a];
          }

          return n = r.call.apply(r, [this].concat(i)), b()(s()(n), "handleChange", function (e) {
            var r = n.props,
                t = r.onChange;
            r.multi || !Array.isArray(e) || 0 !== e.length ? t(e) : t();
          }), n;
        }

        return a()(t, [{
          key: "getOptionFromLabel",
          value: function value(n) {
            var e = this;
            if (Array.isArray(n)) return n.map(function (n) {
              return e.getOptionFromLabel(n);
            });
            var r = this.props,
                t = r.options,
                o = r.getOptionLabel;
            return t.find(function (e) {
              return o(e) === n;
            });
          }
        }, {
          key: "render",
          value: function value() {
            var n = this.props,
                e = n.id,
                r = n.options,
                t = n.getOptionLabel,
                o = n.placeholder,
                i = n.fullWidth,
                a = n.multi,
                c = n.search,
                s = n.size,
                u = n.containsError,
                l = n.disabled,
                f = n.hasTitle,
                d = n.value,
                p = n.noOptionsMessage,
                g = n.loadingMessage,
                h = n.async,
                b = n.asyncDefaultOptions,
                m = n.asyncLoadOptions,
                v = n.onInputChange,
                x = n.onFocus,
                O = n.onBlur,
                w = n.maxMenuHeight,
                j = this.props.numberOfOptions;
            j || !c || a || (j = 5);
            var k = d ? this.getOptionFromLabel(d) : null,
                z = {
              Option: X,
              Placeholder: Y,
              DropdownIndicator: $,
              ClearIndicator: nn
            },
                _ = {
              Placeholder: Y,
              DropdownIndicator: $,
              ClearIndicator: nn
            },
                S = {
              classNamePrefix: "rs",
              inputId: e,
              value: k,
              onChange: this.handleChange,
              onInputChange: v,
              autoBlur: !0,
              getOptionLabel: t,
              components: a ? z : _,
              placeholder: o,
              fullWidth: i,
              size: s,
              hasTitle: f,
              isMulti: a,
              isDisabled: l,
              isSearchable: c,
              onFocus: x,
              onBlur: O,
              hideSelectedOptions: !1,
              closeMenuOnSelect: !a,
              backspaceRemovesValue: !a,
              controlShouldRenderValue: !a,
              containsError: u,
              numberOfOptions: j,
              noOptionsMessage: function noOptionsMessage() {
                return p;
              },
              loadingMessage: function loadingMessage() {
                return g;
              },
              maxMenuHeight: w
            };

            if (h) {
              var F = cn({}, S, {
                defaultOptions: b,
                loadOptions: m
              });
              return y.a.createElement(tn, cn({}, F));
            }

            var P = cn({}, S, {
              options: r
            });
            return y.a.createElement(on, cn({}, P));
          }
        }]), t;
      }(y.a.Component);

      un.defaultProps = {
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onChange: function onChange() {},
        onInputChange: function onInputChange() {},
        id: null,
        options: [],
        getOptionLabel: function getOptionLabel(n) {
          return n.label;
        },
        value: null,
        fullWidth: !1,
        multi: !1,
        search: !1,
        size: "md",
        containsError: !1,
        disabled: !1,
        hasTitle: !1,
        numberOfOptions: null,
        noOptionsMessage: null,
        loadingMessage: null,
        async: !1,
        asyncLoadOptions: function asyncLoadOptions() {},
        asyncDefaultOptions: [],
        maxMenuHeight: null
      };
      e.a = un;
    },
    9: function _(n) {
      n.exports = JSON.parse('{"H1":{"fontFamily":"URWGeometric","fontSize":46,"lineHeight":64},"H2":{"fontFamily":"URWGeometric","fontSize":38,"lineHeight":54},"H3":{"fontFamily":"URWGeometric","fontSize":26,"lineHeight":36},"H4":{"fontFamily":"URWGeometric","fontSize":20,"lineHeight":28},"H5":{"fontFamily":"URWGeometric","fontSize":18,"lineHeight":26},"Body1":{"fontFamily":"URWGeometric","fontSize":16,"lineHeight":22},"Body2":{"fontFamily":"URWGeometric","fontSize":14,"lineHeight":20},"Body3":{"fontFamily":"URWGeometric","fontSize":12,"lineHeight":16},"Body4":{"fontFamily":"URWGeometric","fontSize":10,"lineHeight":14}}');
    }
  });
});